import { axiosInstance } from "@/config/axiosInstance";

// ? Login Admin Action
export const loginAdmin = (data: { email: string; password: string }) =>
  axiosInstance
    .post("/admin/login", data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

// ? Create New Employee Action

export const createNewEmployee = (adminKey: string) => (data: object) =>
  axiosInstance
    .post("/employee/register", data, {
      headers: {
        authorization: `Bearer ${adminKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

// ? Edit Employee Action

export const editEmployee =
  (adminKey: string) => (data: { empId: string; postData: object }) =>
    axiosInstance
      .post(`/employee/edit/${data.empId}`, data.postData, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// ? Create Holiday List Action

export const createHolidayList =
  (adminKey: string) =>
  (data: {
    name: string;
    holidays: {
      holidayName: string;
      date: Date;
      description: string;
    }[];
    halfDays?: {
      dayOfWeek: number;
      minimumHours: number;
    }[];
  }) =>
    axiosInstance
      .post(`/holiday/create`, data, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// ? Edit Holiday List Action

export const editHolidayList =
  (adminKey: string) =>
  (data: {
    holidayListId: string;
    name: string;
    holidays: {
      holidayName: string;
      date: Date;
      description: string;
    }[];
    halfDays?: {
      dayOfWeek: number;
      minimumHours: number;
    }[];
  }) =>
    axiosInstance
      .post(
        `/holiday/edit/list/${data?.holidayListId}`,
        {
          name: data?.name,
          holidays: data?.holidays,
          halfDays: data?.halfDays,
        },
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// ? Change Status of Leave Application Action
export const takeActionOnLeaveApplication =
  (adminKey: string) => (data: { status: string; leaveId: string }) =>
    axiosInstance
      .post(
        `/leave/admin/action/${data.leaveId}`,
        { status: data?.status },
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// ? Delete Leave Application Action
export const deleteLeaveApplicationAsAdmin =
  (adminKey: string) => (data: { leaveId: string }) =>
    axiosInstance
      .post(
        `/leave/delete/${data.leaveId}`,
        {},
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// ? Delete Allowance Action
export const deleteAllowanceAsAdmin =
  (adminKey: string) => (data: { allowanceId: string }) =>
    axiosInstance
      .post(
        `/allowance/delete/${data.allowanceId}`,
        {},
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// ? Delete Announcement Action
export const deleteAnnouncementAsAdmin =
  (adminKey: string) => (data: { announcementId: string }) =>
    axiosInstance
      .post(
        `/announcement/delete/${data.announcementId}`,
        {},
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// ? Delete Loan Action
export const deleteLoanAsAdmin =
  (adminKey: string) => (data: { loanId: string }) =>
    axiosInstance
      .post(
        `/loan/delete/${data.loanId}`,
        {},
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// ? Edit Permission of Employee Action
export const editEmployeePermissions =
  (adminKey: string) =>
  (data: {
    empId: string;
    info?: {
      grant?: {
        permissionType: string;
        doc: string;
      }[];
      remove?: {
        permissionType: string;
        doc: string;
      }[];
    };
  }) =>
    axiosInstance
      .post(`/permissions/edit/${data.empId}`, data?.info, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// ? Change Status of Allowance Request Action
export const takeActionOnAllowanceRequest =
  (adminKey: string) => (data: { status: string; allowanceId: string }) =>
    axiosInstance
      .post(
        `/allowance/admin/action/${data.allowanceId}`,
        { status: data?.status },
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// ? Change Status of Leave Application Action
export const takeActionOnLoanRequest =
  (adminKey: string) =>
  (data: {
    status: string;
    loanId: string;
    totalAmountApproved: number;
    interestRate: number;
    numberOfMonths: number;
  }) =>
    axiosInstance
      .post(
        `/loan/admin/action/${data.loanId}`,
        {
          status: data?.status,
          totalAmountApproved: data?.totalAmountApproved,
          interestRate: data?.interestRate,
          numberOfMonths: data?.numberOfMonths,
        },
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// ? Take Action on Loan Repayment Request Action
export const takeActionOnLoanRepaymentRequestAsAdmin =
  (adminKey: string) =>
  (data: { status: string; repaymentRequestId: string }) =>
    axiosInstance
      .post(
        `/loan/admin/request/action/${data.repaymentRequestId}`,
        { status: data?.status },
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// ? Change Status of Attendance Request Action
export const takeActionOnAttendanceRequest =
  (adminKey: string) =>
  (data: {
    status: string;
    rejectReason: string | undefined;
    attendanceStatus: string;
    attReqId: string;
  }) =>
    axiosInstance
      .post(
        `/attendance/request/action/${data.attReqId}`,
        {
          status: data?.status,
          rejectReason: data?.rejectReason,
          attendanceStatus: data?.attendanceStatus,
        },
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

export const createNewPerformanceLogOfEmployee =
  (adminKey: string) =>
  (data: {
    deduction: number;
    addition: number;
    employee: string;
    reasonPositive: string;
    reasonNegative: string;
  }) =>
    axiosInstance
      .post("/performance/logs/create", data, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

export const editPerformanceReport =
  (adminKey: string) =>
  (data: {
    reportId: string;
    info: {
      remainingPoints: number;
      misconducts: {
        reason: string;
        misconductOn: string | Date;
        dateAdded: string | Date;
        misconductingInvolvingOthers: boolean;
        penalties: string[] | undefined;
        misconductFor: string;
      }[];
    };
  }) =>
    axiosInstance
      .post(`/performance/report/edit/${data?.reportId}`, data?.info, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

export const editAndApproveSalary =
  (adminKey: string) => (data: { salaryId: string; postData: object }) =>
    axiosInstance
      .post(`/salary/edit-approve/${data.salaryId}`, data.postData, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

export const createNewAnnouncement = (adminKey: string) => (data: object) =>
  axiosInstance
    .post("/announcement/create", data, {
      headers: {
        authorization: `Bearer ${adminKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

// ! TODO ACTIONS ! //

// ? Create New TODO Action

export const createNewTodo = (adminKey: string) => (data: object) =>
  axiosInstance
    .post("/todo/create", data, {
      headers: {
        authorization: `Bearer ${adminKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

// ? Create New Loan Request Action
export const createNewLoanForEmployeeByAdmin =
  (employeeKey: string) =>
  (data: {
    totalAmountRequested: number;
    attachment?: string;
    employee: string;
    date: string | Date;
    interestRate: number;
    numberOfMonths: number;
    totalAmountApproved: number;
  }) =>
    axiosInstance
      .post(`/loan/create/admin`, data, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// ? Create New Loan Repayment Action
export const createNewLoanRepaymentByAdmin =
  (adminKey: string) =>
  (data: {
    amount: number;
    attachment?: string;
    loanId: string;
    employeeId: string;
    date: string | Date;
  }) =>
    axiosInstance
      .post(`/loan/create/request/admin`, data, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// ? Edit Loan Repayment Schedule

export const editLoanRepaymentSchedule =
  (adminKey: string) =>
  (data: {
    loanId: string;
    info: {
      id: string;
      date: Date;
    };
  }) =>
    axiosInstance
      .post(`/loan/repayment-edit/${data?.loanId}`, data?.info, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// ? Edit Loan Repayment Schedule

export const generateSalaryComponentsFromDatesheet =
  (adminKey: string) => (data: { sheetId: string }) =>
    axiosInstance
      .post(
        `/salary/generate-salary-datesheet/${data?.sheetId}`,
        {},
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

export const createSalaryByAdmin =
  (adminKey: string) =>
  (data: {
    sheet: string;
    components: {
      type: string;
      name: string;
      amount: number;
    }[];
    totalEarnings: number;
    totalDeductions: number;
    netPay: number;
  }) =>
    axiosInstance
      .post(`/salary/create-salary-datesheet`, data, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

export const submitDatesheetByAdmin =
  (employeeKey: string) =>
  (data: {
    notes?: string;
    monthName: string;
    year: number;
    present: number;
    absent: number;
    halfDay?: number;
    paidLeave: number;
    unpaidLeave: number;
    employee: string;
    holiday: number;
    daysInMonth: number;
  }) =>
    axiosInstance
      .post<{
        message: string;
        sheet: any;
      }>(`/salary/create-datesheet-admin`, data, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

export const editDatesheetByAdmin =
  (employeeKey: string) =>
  (data: {
    id: string;
    info: {
      notes?: string;
      monthName?: string;
      year?: number;
      present?: number;
      absent?: number;
      halfDay?: number;
      paidLeave?: number;
      unpaidLeave?: number;
      employee?: string;
      holiday?: number;
      deleted?: boolean;
    };
  }) =>
    axiosInstance
      .post<{
        message: string;
        sheet: any;
      }>(`/salary/edit-datesheet-admin/${data?.id}`, data?.info, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

export const uploadTimesheetCSVFile =
  (adminKey: string) => async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    return axiosInstance
      .post("/salary/upload/admin/post-2", formData, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => response.data);
  };
